export default "__VITE_ASSET__d63f3ed2__"